import React from 'react'
// libs
import styled from 'styled-components'
// components
import MaterialAvatar, { AvatarProps } from '@mui/material/Avatar'
import { HoverablePopover } from 'components/UI'
// themes
import { colors } from 'themes'
// types
import { IPosition, IUser } from 'types/graphql'
// utils
import { get } from 'lodash'
import { generateUserName } from 'utils/user'

export const StyledMaterialAvatar = styled((props: AvatarProps) => <MaterialAvatar {...props} />)<{ src: string }>`
  && {
    border: ${({ src }) => (src ? 'none' : `2px solid ${colors.white}`)};
    box-shadow:
      0 1px 3px 0 rgba(0, 0, 0, 0.2),
      0 1px 1px 0 rgba(0, 0, 0, 0.14),
      0 0 0 0 rgba(0, 0, 0, 0.12);
  }
`

interface Props {
  user?: IUser | IPosition
  counter?: string
  withHover?: boolean
  handleOnClick?: () => void
}

const Avatar: React.FC<Props> = ({ user, withHover, handleOnClick, counter }) => {
  if (!user) {
    return null
  }

  let position, description

  if ('description' in user && user.description?.trim()) {
    position = user
    description = get(position.description.trim(), '[0]', '')
  } else {
    description = counter || get(user, 'firstName[0]', '') + get(user, 'lastName[0]', '')
  }

  return withHover ? (
    <HoverablePopover
      disableAutoFocus
      trigger={
        <StyledMaterialAvatar src={get(user, 'avatarUrl')} onClick={handleOnClick}>
          {description}
        </StyledMaterialAvatar>
      }>
      {position ? position.description : generateUserName(user)}
    </HoverablePopover>
  ) : (
    <StyledMaterialAvatar src={get(user, 'avatarUrl')}>{description}</StyledMaterialAvatar>
  )
}

export default Avatar
